import * as ActionType from '../actions/types'

export const INITIAL_STATE = {
  // contains the previously searched params (the last executed search)
  prevParams: {
    query: '', // search key word
    key: '', // k50, 1-275 something like this
    type: '', // ops or icd
    location: '',
    radius: '', // zero as value for nationwide
  },
  // contains search params for new Search
  params: {
    query: '',
    location: '',
    radius: '',
    key: '',
    type: '',
  },
  // use for distance calculation
  searchLocation: {
    lng: false,
    lat: false,
  },
  count: 0, // number of results
  isTreatmentReason: false, // hospital only (treatment reason based search)
  isAop: false, // hospital only (aop hit)
  qsrIdentifier: [], // hospital only (to control dynamic value render, similar to compare)
  noResults: false,
  error: false,
  clientHasSearched: false, // flag for initial search
  from: 0, // pagination
  size: 10, // pagination
  location: {}, // used for result map (center)
  results: {}, // result collection
  generalTooltips: {}, // global tooltips
  generalHints: [], // global search hints
  factsBox: [], // used on cross search (health information's)
  showDetails: false, // hospital only flag for open all result tiles
  services: null, // array of aok services
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionType.SET_TYPE_SPECIFIC_SEARCH_PARAMS:
      return {
        ...state,
        prevParams: action.payload,
        params: action.payload,
      }

    // set ALL query params
    case ActionType.SET_SEARCH_LOCATION_DISTANCE:
      return {
        ...state,
        results: action.payload,
      }
    // set ALL query params
    case ActionType.SET_SEARCH_QUERY:
      return {
        ...state,
        params: action.payload,
      }
    // set ALL query prevParams
    // case ActionType.SET_SEARCH_PARAMS:
    //   return {
    //     ...state,
    //     params: {
    //       ...state.params,
    //       ...action.payload.params,
    //     },
    //     prevParams: {
    //       ...state.prevParams,
    //       ...action.payload.prevParams,
    //     },
    //   }
    // reset location (inclusive zip code) and location coordinates
    case ActionType.RESET_LOCATION_PARAM:
      return {
        ...state,
        params: {
          ...state.params,
          location: '',
          radius: action.payload,
        },
      }

    // reset ONLY query params
    case ActionType.RESET_QUERY_PARAM:
      return {
        ...state,
        params: {
          ...state.params,
          query: '',
        },
      }

    // set ONLY default radius
    case ActionType.SET_DEFAULT_RADIUS:
      return {
        ...state,
        params: {
          ...state.params,
          radius: action.payload,
        },
      }

    // set search results && params
    case ActionType.SET_SEARCH_RESULTS:
      return {
        ...state,
        prevParams: {
          ...action.payload.prevParams,
        },
        params: {
          ...action.payload.params,
        },
        isTreatmentReason: action.payload.isTreatmentReason,
        isAop: action.payload.isAop,
        results: {
          ...action.payload.results,
        },
        count: action.payload.count,
        noResults: action.payload.noResults,
        location: action.payload.location,
        clientHasSearched: true,
        from: action.payload.from,
        generalTooltips: action.payload.generalTooltips,
        generalHints: action.payload.generalHints,
        factsBox: action.payload.factsBox,
        showDetails: action.payload.showDetails,
        qsrIdentifier: action.payload.qsrIdentifier,
        services: action.payload.services,
        searchLocation: action.payload.searchLocation,
      }

    case ActionType.ADD_SEARCH_RESULTS:
      return {
        ...state,
        results: {
          ...[
            ...Object.keys(state.results).map((r) => state.results[r]),
            ...action.payload.results,
          ],
        },
        qsrIdentifier: action.payload.qsrIdentifier,
        from: action.payload.from,
        size: action.payload.size,
      }

    // only update results
    case ActionType.UPDATE_SEARCH_RESULTS:
      return {
        ...state,
        isTreatmentReason: action.payload.isTreatmentReason,
        results: { ...action.payload.results },
        count: action.payload.count,
        noResults: action.payload.noResults,
        showDetails: action.payload.showDetails,
        services: action.payload.services,
        qsrIdentifier: action.payload.qsrIdentifier,
      }

    // Toggle isBooked value
    case ActionType.SET_SEARCH_RESULTS_IS_BOOKED:
      const { index } = action.payload
      const isBooked = state.results[index].isBooked
        ? !state.results[index].isBooked
        : true

      return {
        ...state,
        results: {
          ...state.results,
          [index]: {
            ...state.results[index],
            isBooked,
          },
        },
      }

    // reset all search params and results
    case ActionType.RESET_SEARCH:
      return {
        ...INITIAL_STATE,
        clientHasSearched: false,
      }

    // only update qsr identifiers (compare only)
    case ActionType.UPDATE_QSR_IDENTIFIER:
      return {
        ...state,
        qsrIdentifier: [...action.payload],
      }

    default:
      return state
  }
}
